import { ThumbsDown, ThumbsUp } from 'lucide-react';

const inlineIconClass =
  'mr-1 inline-block size-[1.05em] shrink-0 align-[-0.125em] stroke-[2.5]';

export function IncidentThumbsDownInline() {
  return (
    <ThumbsDown className={`${inlineIconClass} text-red-500`} aria-hidden />
  );
}

export function IncidentThumbsUpInline() {
  return (
    <ThumbsUp className={`${inlineIconClass} text-blue-500`} aria-hidden />
  );
}
